module.exports = __webpack_public_path__ + "static/media/burka.9c7e3eb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/burka.jpg
// module id = 405
// module chunks = 0